import type {
	LWApiPublicBillingPaymentMakeParamsRawI,
	LWApiPublicBillingPaymentMakeResultRawI,
} from '@liquidweb-dev/club-sauce/public/billing/payment/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import { BILLING_BALANCE_QUERY_KEY } from 'modules/queries/billing/useBalance';

const useBillingPaymentMake = () => {
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicBillingPaymentMakeResultRawI,
		ApiErrorI,
		LWApiPublicBillingPaymentMakeParamsRawI
	>({
		mutationFn: (params) => api.billing.payment.apiRaw.make(params),

		// `onSettled`, not `onSuccess`: this call takes the payment, and an error
		// response does not mean no payment was taken - a request that never came
		// back may well have landed. Refetching either way costs a request and
		// keeps a settled balance from being paid a second time.
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: [BILLING_BALANCE_QUERY_KEY],
			});
		},
	});
};

export default useBillingPaymentMake;
